import { createSlice } from '@reduxjs/toolkit';
import ReducerRegistry from '../base/redux/ReducerRegistry';
const initialState = {
    latestVMPNotificationId: null,
};
const vmpNotificationSlice = createSlice({
    name: 'features/vmp-notification',
    initialState,
    reducers: {
        updateLatestVMPNotificationId: (state, action) => {
            state.latestVMPNotificationId = action.payload;
        }
    }
});
ReducerRegistry.register('features/vmp-notification', vmpNotificationSlice.reducer);
export const { updateLatestVMPNotificationId } = vmpNotificationSlice.actions;
export default vmpNotificationSlice.reducer;
